function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 283.5 283.5"
}, props), /*#__PURE__*/React.createElement("title", null, "191217_VF_Icon_List_display"), /*#__PURE__*/React.createElement("path", {
  d: "M78 127.6h163v28.3H78zM78 56.7h205.5V85H78zM77.9 198.4h205.5v28.3H77.9zM39 53.3c-9.7 0-17.6 5.5-17.6 17.6S29.2 88.5 39 88.5 56.6 83 56.6 70.9 48.7 53.3 39 53.3zM39 124.1c-9.7 0-17.6 5.5-17.6 17.6s7.9 17.6 17.6 17.6 17.6-5.5 17.6-17.6-7.9-17.6-17.6-17.6zM39 195c-9.7 0-17.6 5.5-17.6 17.6s7.9 17.6 17.6 17.6 17.6-5.5 17.6-17.6S48.7 195 39 195z"
})));